import ExpandableSection from "../component/_expandableSection";

document.addEventListener('DOMContentLoaded', function () {
    const processSections = document.querySelectorAll('.js-section-process-stages-block__item');

    processSections.forEach((accordion) => {
        new ExpandableSection(
            '.js-section-process-stages-block__item',
            '.js-section-process-stages-block-question-wrapper',
            '.js-section-process-stages-block__stages-description',
            '.js-section-process-stages-block__chevron',
            false,
            true,
            true,
            true,
            true
        );
    });

    function createHeightObserver(contentSelector, iconSelector) {
        const contentElement = document.querySelector(contentSelector);
        const iconElement = document.querySelector(iconSelector);

        if (contentElement && iconElement) {
            const resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    const newHeight = entry.contentRect.height;
                    iconElement.style.height = `${newHeight}px`;
                }
            });

            resizeObserver.observe(contentElement);
        }
    }

    createHeightObserver('.js-section-process-stages-block__first-content', '.js-section-process-stages-block__first-icon');

    createHeightObserver('.js-section-process-stages-block__second-content', '.js-section-process-stages-block__second-icon');

    if (window.innerWidth > 768) {
    const stageDescriptions = document.querySelectorAll('.js-section-process-stages-block__stages-description');

    const updateMargins = (element) => {
        const currentHeight = window.getComputedStyle(element).height;
        if (currentHeight !== '0') {
            element.style.marginTop = '-150px';
            element.style.marginBottom = '32px';
        } else {
            element.style.marginTop = '';
            element.style.marginBottom = '';
        }
    };

    stageDescriptions.forEach(stageDescription => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === 'style') {
                    updateMargins(mutation.target);

                }
            });
        });

        observer.observe(stageDescription, {
            attributes: true,
            attributeFilter: ['style'],
        });

        updateMargins(stageDescription);
    });
    }

    if (window.innerWidth < 768) {
        const stageDescriptions = document.querySelectorAll('.js-section-process-stages-block__stages-description');

        const updateMargins = (element) => {
            const currentHeight = window.getComputedStyle(element).height;
            if (currentHeight !== '0') {
                element.style.marginTop = '0';
                element.style.marginBottom = '16px';
            } else {
                element.style.marginTop = '';
                element.style.marginBottom = '';
            }
        };

        stageDescriptions.forEach(stageDescription => {
            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.attributeName === 'style') {
                        updateMargins(mutation.target);

                    }
                });
            });

            observer.observe(stageDescription, {
                attributes: true,
                attributeFilter: ['style'],
            });

            updateMargins(stageDescription);
        });
    }

});
